'use strict';

const codes = [
    { code: '101Y00000X', label: 'Counselor' },
    {
        code: '101YA0400X',
        label: 'Counselor / Addiction (Substance Use Disorder)'
    },
    { code: '101YM0800X', label: 'Counselor / Mental Health' },
    { code: '101YP1600X', label: 'Counselor / Pastoral' },
    { code: '101YP2500X', label: 'Counselor / Professional' },
    { code: '101YS0200X', label: 'Counselor / School' },
    { code: '102L00000X', label: 'Psychoanalyst' },
    { code: '102X00000X', label: 'Poetry Therapist' },
    { code: '103G00000X', label: 'Clinical Neuropsychologist' },
    { code: '103GC0700X', label: 'Clinical Neuropsychologist / Clinical' },
    { code: '103K00000X', label: 'Behavioral Analyst' },
    { code: '103T00000X', label: 'Psychologist' },
    {
        code: '103TA0400X',
        label: 'Psychologist / Addiction (Substance Use Disorder)'
    },
    { code: '103TA0700X', label: 'Psychologist / Adult Development & Aging' },
    { code: '103TB0200X', label: 'Psychologist / Cognitive & Behavioral' },
    { code: '103TC0700X', label: 'Psychologist / Clinical' },
    { code: '103TC1900X', label: 'Psychologist / Counseling' },
    { code: '103TC2200X', label: 'Psychologist / Clinical Child & Adolescent' },
    { code: '103TE1000X', label: 'Psychologist / Educational' },
    { code: '103TE1100X', label: 'Psychologist / Exercise & Sports' },
    { code: '103TF0000X', label: 'Psychologist / Family' },
    { code: '103TF0200X', label: 'Psychologist / Forensic' },
    { code: '103TH0004X', label: 'Psychologist / Health' },
    { code: '103TH0100X', label: 'Psychologist / Health Service' },
    { code: '103TM1700X', label: 'Psychologist / Men & Masculinity' },
    {
        code: '103TM1800X',
        label: 'Psychologist / Mental Retardation & Developmental Disabilities'
    },
    { code: '103TP0016X', label: 'Psychologist / Prescribing (Medical)' },
    { code: '103TP0814X', label: 'Psychologist / Psychoanalysis' },
    { code: '103TP2700X', label: 'Psychologist / Psychotherapy' },
    { code: '103TP2701X', label: 'Psychologist / Group Psychotherapy' },
    { code: '103TR0400X', label: 'Psychologist / Rehabilitation' },
    { code: '103TS0200X', label: 'Psychologist / School' },
    { code: '103TW0100X', label: 'Psychologist / Women' },
    { code: '104100000X', label: 'Social Worker' },
    { code: '1041C0700X', label: 'Social Worker / Clinical' },
    { code: '1041S0200X', label: 'Social Worker / School' },
    { code: '106E00000X', label: 'Assistant Behavior Analyst' },
    { code: '163WP0000X', label: 'Registered Nurse / Pain Management' },
    { code: '163WP0200X', label: 'Registered Nurse / Pediatrics' },
    { code: '163WP0218X', label: 'Registered Nurse / Pediatric Oncology' },
    { code: '106H00000X', label: 'Marriage & Family Therapist' },
    { code: '106S00000X', label: 'Behavior Technician' },
    { code: '111N00000X', label: 'Chiropractor' },
    {
        code: '111NI0013X',
        label: 'Chiropractor / Independent Medical Examiner'
    },
    { code: '111NI0900X', label: 'Chiropractor / Internist' },
    { code: '111NN0400X', label: 'Chiropractor / Neurology' },
    { code: '111NN1001X', label: 'Chiropractor / Nutrition' },
    { code: '111NP0017X', label: 'Chiropractor / Pediatric Chiropractor' },
    { code: '111NR0200X', label: 'Chiropractor / Radiology' },
    { code: '111NR0400X', label: 'Chiropractor / Rehabilitation' },
    { code: '111NS0005X', label: 'Chiropractor / Sports Physician' },
    { code: '111NT0100X', label: 'Chiropractor / Thermography' },
    { code: '111NX0100X', label: 'Chiropractor / Occupational Health' },
    { code: '111NX0800X', label: 'Chiropractor / Orthopedic' },
    { code: '122300000X', label: 'Dentist' },
    { code: '1223D0001X', label: 'Dentist / Dental Public Health' },
    { code: '1223D0004X', label: 'Dentist / Dentist Anesthesiologist' },
    { code: '1223E0200X', label: 'Dentist / Endodontics' },
    { code: '1223G0001X', label: 'Dentist / General Practice' },
    { code: '126900000X', label: 'Dental Laboratory Technician' },
    { code: '1223P0106X', label: 'Dentist / Oral and Maxillofacial Pathology' },
    { code: '1223P0221X', label: 'Dentist / Pediatric Dentistry' },
    { code: '1223P0300X', label: 'Dentist / Periodontics' },
    { code: '1223P0700X', label: 'Dentist / Prosthodontics' },
    { code: '1223S0112X', label: 'Dentist / Oral and Maxillofacial Surgery' },
    { code: '1223X0008X', label: 'Dentist / Oral and Maxillofacial Radiology' },
    {
        code: '1223X0400X',
        label: 'Dentist / Orthodontics and Dentofacial Orthopedics'
    },
    { code: '122400000X', label: 'Denturist' },
    { code: '124Q00000X', label: 'Dental Hygienist' },
    { code: '125J00000X', label: 'Dental Therapist' },
    { code: '125K00000X', label: 'Advanced Practice Dental Therapist' },
    { code: '125Q00000X', label: 'Oral Medicinist' },
    { code: '126800000X', label: 'Dental Assistant' },
    { code: '132700000X', label: 'Dietary Manager' },
    { code: '133N00000X', label: 'Nutritionist' },
    { code: '133NN1002X', label: 'Nutritionist / Nutrition, Education' },
    { code: '133V00000X', label: 'Dietitian, Registered' },
    {
        code: '133VN1004X',
        label: 'Dietitian, Registered / Nutrition, Pediatric'
    },
    { code: '133VN1005X', label: 'Dietitian, Registered / Nutrition, Renal' },
    {
        code: '133VN1006X',
        label: 'Dietitian, Registered / Nutrition, Metabolic'
    },
    { code: '136A00000X', label: 'Dietetic Technician, Registered' },
    { code: '146D00000X', label: 'Personal Emergency Response Attendant' },
    { code: '146L00000X', label: 'Emergency Medical Technician, Paramedic' },
    { code: '146M00000X', label: 'Emergency Medical Technician, Intermediate' },
    { code: '146N00000X', label: 'Emergency Medical Technician, Basic' },
    { code: '152W00000X', label: 'Optometrist' },
    {
        code: '152WC0802X',
        label: 'Optometrist / Corneal and Contact Management'
    },
    { code: '152WL0500X', label: 'Optometrist / Low Vision Rehabilitation' },
    { code: '152WP0200X', label: 'Optometrist / Pediatrics' },
    { code: '152WS0006X', label: 'Optometrist / Sports Vision' },
    { code: '152WV0400X', label: 'Optometrist / Vision Therapy' },
    { code: '152WX0102X', label: 'Optometrist / Occupational Vision' },
    { code: '156F00000X', label: 'Technician/Technologist' },
    { code: '156FC0800X', label: 'Technician/Technologist / Contact Lens' },
    {
        code: '156FC0801X',
        label: 'Technician/Technologist / Contact Lens Fitter'
    },
    { code: '156FX1100X', label: 'Technician/Technologist / Ophthalmic' },
    {
        code: '156FX1101X',
        label: 'Technician/Technologist / Ophthalmic Assistant'
    },
    {
        code: '156FX1201X',
        label: 'Technician/Technologist / Optometric Assistant'
    },
    {
        code: '156FX1202X',
        label: 'Technician/Technologist / Optometric Technician'
    },
    { code: '156FX1700X', label: 'Technician/Technologist / Ocularist' },
    { code: '156FX1800X', label: 'Technician/Technologist / Optician' },
    { code: '156FX1900X', label: 'Technician/Technologist / Orthoptist' },
    { code: '163W00000X', label: 'Registered Nurse' },
    {
        code: '163WA0400X',
        label: 'Registered Nurse / Addiction (Substance Use Disorder)'
    },
    { code: '163WA2000X', label: 'Registered Nurse / Administrator' },
    { code: '163WC0200X', label: 'Registered Nurse / Critical Care Medicine' },
    { code: '163WC0400X', label: 'Registered Nurse / Case Management' },
    { code: '163WC1400X', label: 'Registered Nurse / College Health' },
    { code: '163WC1500X', label: 'Registered Nurse / Community Health' },
    {
        code: '163WC1600X',
        label: 'Registered Nurse / Continuing Education/Staff Development'
    },
    { code: '163WC2100X', label: 'Registered Nurse / Continence Care' },
    { code: '163WC3500X', label: 'Registered Nurse / Cardiac Rehabilitation' },
    { code: '163WD0400X', label: 'Registered Nurse / Diabetes Educator' },
    { code: '163WD1100X', label: 'Registered Nurse / Dialysis, Peritoneal' },
    { code: '163WE0003X', label: 'Registered Nurse / Emergency' },
    { code: '163WE0900X', label: 'Registered Nurse / Enterostomal Therapy' },
    { code: '163WF0300X', label: 'Registered Nurse / Flight' },
    { code: '163WG0000X', label: 'Registered Nurse / General Practice' },
    { code: '163WG0100X', label: 'Registered Nurse / Gastroenterology' },
    { code: '163WG0600X', label: 'Registered Nurse / Gerontology' },
    { code: '163WH0200X', label: 'Registered Nurse / Home Health' },
    { code: '163WH0500X', label: 'Registered Nurse / Hemodialysis' },
    { code: '163WH1000X', label: 'Registered Nurse / Hospice' },
    { code: '163WI0500X', label: 'Registered Nurse / Infusion Therapy' },
    { code: '163WI0600X', label: 'Registered Nurse / Infection Control' },
    { code: '163WL0100X', label: 'Registered Nurse / Lactation Consultant' },
    { code: '163WM0102X', label: 'Registered Nurse / Maternal Newborn' },
    { code: '163WM0705X', label: 'Registered Nurse / Medical-Surgical' },
    {
        code: '163WM1400X',
        label: 'Registered Nurse / Nurse Massage Therapist (NMT)'
    },
    { code: '163WN0002X', label: 'Registered Nurse / Neonatal Intensive Care' },
    { code: '163WN0003X', label: 'Registered Nurse / Neonatal, Low-Risk' },
    { code: '163WN0300X', label: 'Registered Nurse / Nephrology' },
    { code: '163WN0800X', label: 'Registered Nurse / Neuroscience' },
    { code: '163WN1003X', label: 'Registered Nurse / Nutrition Support' },
    {
        code: '163WP0807X',
        label: 'Registered Nurse / Psych/Mental Health, Child & Adolescent'
    },
    { code: '163WP0808X', label: 'Registered Nurse / Psych/Mental Health' },
    {
        code: '163WP0809X',
        label: 'Registered Nurse / Psych/Mental Health, Adult'
    },
    { code: '163WP1700X', label: 'Registered Nurse / Perinatal' },
    { code: '163WP2201X', label: 'Registered Nurse / Ambulatory Care' },
    {
        code: '163WR0006X',
        label: 'Registered Nurse / Registered Nurse First Assistant'
    },
    { code: '163WR0400X', label: 'Registered Nurse / Rehabilitation' },
    {
        code: '163WR1000X',
        label: 'Registered Nurse / Reproductive Endocrinology/Infertility'
    },
    { code: '163WS0121X', label: 'Registered Nurse / Plastic Surgery' },
    { code: '163WS0200X', label: 'Registered Nurse / School' },
    { code: '163WU0100X', label: 'Registered Nurse / Urology' },
    { code: '163WW0000X', label: 'Registered Nurse / Wound Care' },
    {
        code: '163WW0101X',
        label: "Registered Nurse / Women's Health Care, Ambulatory"
    },
    { code: '163WX0002X', label: 'Registered Nurse / Obstetric, High-Risk' },
    { code: '163WX0003X', label: 'Registered Nurse / Obstetric, Inpatient' },
    { code: '163WX0106X', label: 'Registered Nurse / Occupational Health' },
    { code: '163WX0200X', label: 'Registered Nurse / Oncology' },
    {
        code: '163WX0601X',
        label: 'Registered Nurse / Otorhinolaryngology & Head-Neck'
    },
    { code: '163WX0800X', label: 'Registered Nurse / Orthopedic' },
    { code: '163WX1100X', label: 'Registered Nurse / Ophthalmic' },
    { code: '163WX1500X', label: 'Registered Nurse / Ostomy Care' },
    { code: '164W00000X', label: 'Licensed Practical Nurse' },
    { code: '164X00000X', label: 'Licensed Vocational Nurse' },
    { code: '167G00000X', label: 'Licensed Psychiatric Technician' },
    { code: '170100000X', label: 'Medical Genetics, Ph.D. Medical Genetics' },
    { code: '170300000X', label: 'Genetic Counselor, MS' },
    { code: '171000000X', label: 'Military Health Care Provider' },
    {
        code: '1710I1002X',
        label: 'Military Health Care Provider / Independent Duty Corpsman'
    },
    { code: '176B00000X', label: 'Midwife' },
    {
        code: '246QH0401X',
        label: 'Spec/Tech, Pathology / Hemapheresis Practitioner'
    },
    { code: '282NC2000X', label: 'General Acute Care Hospital / Children' },
    {
        code: '1710I1003X',
        label: 'Military Health Care Provider / Independent Duty Medical Technicians'
    },
    { code: '171100000X', label: 'Acupuncturist' },
    { code: '171M00000X', label: 'Case Manager/Care Coordinator' },
    { code: '171R00000X', label: 'Interpreter' },
    { code: '171W00000X', label: 'Contractor' },
    { code: '171WH0202X', label: 'Contractor / Home Modifications' },
    { code: '171WV0202X', label: 'Contractor / Vehicle Modifications' },
    { code: '172A00000X', label: 'Driver' },
    { code: '172M00000X', label: 'Mechanotherapist' },
    { code: '172P00000X', label: 'Naprapath' },
    { code: '172V00000X', label: 'Community Health Worker' },
    { code: '173000000X', label: 'Legal Medicine' },
    { code: '176P00000X', label: 'Funeral Director' },
    { code: '177F00000X', label: 'Lodging' },
    { code: '246QH0600X', label: 'Spec/Tech, Pathology / Histology' },
    { code: '246QI0000X', label: 'Spec/Tech, Pathology / Immunology' },
    { code: '173C00000X', label: 'Reflexologist' },
    { code: '173F00000X', label: 'Sleep Specialist, PhD' },
    { code: '174200000X', label: 'Meals' },
    { code: '174400000X', label: 'Specialist' },
    { code: '1744G0900X', label: 'Specialist / Graphics Designer' },
    { code: '1744P3200X', label: 'Specialist / Prosthetics Case Management' },
    { code: '1744R1102X', label: 'Specialist / Research Study' },
    {
        code: '1744R1103X',
        label: 'Specialist / Research Data Abstracter/Coder'
    },
    { code: '174H00000X', label: 'Health Educator' },
    { code: '174M00000X', label: 'Veterinarian' },
    { code: '174MM1900X', label: 'Veterinarian / Medical Research' },
    { code: '174N00000X', label: 'Lactation Consultant, Non-RN' },
    { code: '174V00000X', label: 'Clinical Ethicist' },
    { code: '175F00000X', label: 'Naturopath' },
    { code: '175L00000X', label: 'Homeopath' },
    { code: '175M00000X', label: 'Midwife, Lay' },
    { code: '175T00000X', label: 'Peer Specialist' },
    {
        code: '2278P1004X',
        label: 'Respiratory Therapist, Certified / Pulmonary Diagnostics'
    },
    { code: '183500000X', label: 'Pharmacist' },
    { code: '1835C0205X', label: 'Pharmacist / Critical Care' },
    { code: '1835G0000X', label: 'Pharmacist / General Practice' },
    { code: '1835G0303X', label: 'Pharmacist / Geriatric' },
    { code: '1835N0905X', label: 'Pharmacist / Nuclear' },
    { code: '1835N1003X', label: 'Pharmacist / Nutrition Support' },
    {
        code: '1835P0018X',
        label: 'Pharmacist / Pharmacist Clinician (PhC)/ Clinical Pharmacy Specialist'
    },
    { code: '1835P0200X', label: 'Pharmacist / Pediatrics' },
    { code: '1835P1200X', label: 'Pharmacist / Pharmacotherapy' },
    { code: '1835P1300X', label: 'Pharmacist / Psychiatric' },
    { code: '1835P2201X', label: 'Pharmacist / Ambulatory Care' },
    { code: '1835X0200X', label: 'Pharmacist / Oncology' },
    { code: '183700000X', label: 'Pharmacy Technician' },
    { code: '193200000X', label: 'Multi-Specialty' },
    { code: '193400000X', label: 'Single Specialty' },
    { code: '202C00000X', label: 'Independent Medical Examiner' },
    { code: '207LC0200X', label: 'Anesthesiology / Critical Care Medicine' },
    { code: '202K00000X', label: 'Phlebology' },
    {
        code: '204C00000X',
        label: 'Neuromusculoskeletal Medicine, Sports Medicine'
    },
    { code: '204D00000X', label: 'Neuromusculoskeletal Medicine & OMM' },
    { code: '204E00000X', label: 'Oral & Maxillofacial Surgery' },
    { code: '204F00000X', label: 'Transplant Surgery' },
    { code: '204R00000X', label: 'Electrodiagnostic Medicine' },
    { code: '207K00000X', label: 'Allergy & Immunology' },
    { code: '207KA0200X', label: 'Allergy & Immunology / Allergy' },
    {
        code: '207KI0005X',
        label: 'Allergy & Immunology / Clinical & Laboratory Immunology'
    },
    { code: '207L00000X', label: 'Anesthesiology' },
    { code: '207LA0401X', label: 'Anesthesiology / Addiction Medicine' },
    { code: '2085R0001X', label: 'Radiology / Radiation Oncology' },
    { code: '282NR1301X', label: 'General Acute Care Hospital / Rural' },
    {
        code: '207LH0002X',
        label: 'Anesthesiology / Hospice and Palliative Medicine'
    },
    { code: '207LP2900X', label: 'Anesthesiology / Pain Medicine' },
    { code: '207LP3000X', label: 'Anesthesiology / Pediatric Anesthesiology' },
    { code: '207N00000X', label: 'Dermatology' },
    { code: '207ND0101X', label: 'Dermatology / MOHS-Micrographic Surgery' },
    { code: '207ND0900X', label: 'Dermatology / Dermatopathology' },
    {
        code: '207NI0002X',
        label: 'Dermatology / Clinical & Laboratory Dermatological Immunology'
    },
    { code: '207NP0225X', label: 'Dermatology / Pediatric Dermatology' },
    { code: '207NS0135X', label: 'Dermatology / Procedural Dermatology' },
    { code: '207P00000X', label: 'Emergency Medicine' },
    {
        code: '207PE0004X',
        label: 'Emergency Medicine / Emergency Medical Services'
    },
    {
        code: '207PE0005X',
        label: 'Emergency Medicine / Undersea and Hyperbaric Medicine'
    },
    {
        code: '207PH0002X',
        label: 'Emergency Medicine / Hospice and Palliative Medicine'
    },
    {
        code: '207PP0204X',
        label: 'Emergency Medicine / Pediatric Emergency Medicine'
    },
    { code: '207PS0010X', label: 'Emergency Medicine / Sports Medicine' },
    { code: '207PT0002X', label: 'Emergency Medicine / Medical Toxicology' },
    { code: '207Q00000X', label: 'Family Medicine' },
    { code: '208M00000X', label: 'Hospitalist' },
    { code: '207QA0000X', label: 'Family Medicine / Adolescent Medicine' },
    { code: '207QA0401X', label: 'Family Medicine / Addiction Medicine' },
    { code: '207QA0505X', label: 'Family Medicine / Adult Medicine' },
    { code: '207QB0002X', label: 'Family Medicine / Obesity Medicine' },
    { code: '207QG0300X', label: 'Family Medicine / Geriatric Medicine' },
    {
        code: '207QH0002X',
        label: 'Family Medicine / Hospice and Palliative Medicine'
    },
    { code: '207QS0010X', label: 'Family Medicine / Sports Medicine' },
    { code: '207QS1201X', label: 'Family Medicine / Sleep Medicine' },
    {
        code: '207RE0101X',
        label: 'Internal Medicine / Endocrinology, Diabetes & Metabolism'
    },
    {
        code: '246QL0900X',
        label: 'Spec/Tech, Pathology / Laboratory Management'
    },
    { code: '207R00000X', label: 'Internal Medicine' },
    { code: '207RA0000X', label: 'Internal Medicine / Adolescent Medicine' },
    {
        code: '207RA0001X',
        label: 'Internal Medicine / Advanced Heart Failure and Transplant Cardiology'
    },
    { code: '207RA0201X', label: 'Internal Medicine / Allergy & Immunology' },
    { code: '207RA0401X', label: 'Internal Medicine / Addiction Medicine' },
    { code: '207RB0002X', label: 'Internal Medicine / Obesity Medicine' },
    { code: '207RC0000X', label: 'Internal Medicine / Cardiovascular Disease' },
    {
        code: '207RC0001X',
        label: 'Internal Medicine / Clinical Cardiac Electrophysiology'
    },
    { code: '207RC0200X', label: 'Internal Medicine / Critical Care Medicine' },
    { code: '207RG0100X', label: 'Internal Medicine / Gastroenterology' },
    { code: '207RG0300X', label: 'Internal Medicine / Geriatric Medicine' },
    { code: '207RH0000X', label: 'Internal Medicine / Hematology' },
    {
        code: '207RH0002X',
        label: 'Internal Medicine / Hospice and Palliative Medicine'
    },
    { code: '207RH0003X', label: 'Internal Medicine / Hematology & Oncology' },
    {
        code: '207RH0005X',
        label: 'Internal Medicine / Hypertension Specialist'
    },
    {
        code: '207RI0001X',
        label: 'Internal Medicine / Clinical & Laboratory Immunology'
    },
    { code: '207RI0008X', label: 'Internal Medicine / Hepatology' },
    {
        code: '207RI0011X',
        label: 'Internal Medicine / Interventional Cardiology'
    },
    {
        code: '207UN0902X',
        label: 'Nuclear Medicine / Nuclear Imaging & Therapy'
    },
    { code: '207RI0200X', label: 'Internal Medicine / Infectious Disease' },
    {
        code: '207RM1200X',
        label: 'Internal Medicine / Magnetic Resonance Imaging (MRI)'
    },
    { code: '207RN0300X', label: 'Internal Medicine / Nephrology' },
    { code: '207RP1001X', label: 'Internal Medicine / Pulmonary Disease' },
    { code: '207RR0500X', label: 'Internal Medicine / Rheumatology' },
    { code: '207RS0010X', label: 'Internal Medicine / Sports Medicine' },
    { code: '207RS0012X', label: 'Internal Medicine / Sleep Medicine' },
    { code: '207RT0003X', label: 'Internal Medicine / Transplant Hepatology' },
    { code: '207RX0202X', label: 'Internal Medicine / Medical Oncology' },
    {
        code: '207UN0903X',
        label: 'Nuclear Medicine / In Vivo & In Vitro Nuclear Medicine'
    },
    {
        code: '246QL0901X',
        label: 'Spec/Tech, Pathology / Laboratory Management, Diplomate'
    },
    { code: '207SC0300X', label: 'Medical Genetics / Clinical Cytogenetic' },
    {
        code: '207SG0201X',
        label: 'Medical Genetics / Clinical Genetics (M.D.)'
    },
    {
        code: '207SG0202X',
        label: 'Medical Genetics / Clinical Biochemical Genetics'
    },
    {
        code: '207SG0203X',
        label: 'Medical Genetics / Clinical Molecular Genetics'
    },
    { code: '207SG0205X', label: 'Medical Genetics / Ph.D. Medical Genetics' },
    {
        code: '207SM0001X',
        label: 'Medical Genetics / Molecular Genetic Pathology'
    },
    { code: '207T00000X', label: 'Neurological Surgery' },
    { code: '207U00000X', label: 'Nuclear Medicine' },
    { code: '207UN0901X', label: 'Nuclear Medicine / Nuclear Cardiology' },
    {
        code: '246QM0706X',
        label: 'Spec/Tech, Pathology / Medical Technologist'
    },
    { code: '207V00000X', label: 'Obstetrics & Gynecology' },
    { code: '207VB0002X', label: 'Obstetrics & Gynecology / Obesity Medicine' },
    {
        code: '207VC0200X',
        label: 'Obstetrics & Gynecology / Critical Care Medicine'
    },
    {
        code: '207VE0102X',
        label: 'Obstetrics & Gynecology / Reproductive Endocrinology'
    },
    {
        code: '207VF0040X',
        label: 'Obstetrics & Gynecology / Female Pelvic Medicine and Reconstructive Surgery'
    },
    { code: '207VG0400X', label: 'Obstetrics & Gynecology / Gynecology' },
    {
        code: '207VH0002X',
        label: 'Obstetrics & Gynecology / Hospice and Palliative Medicine'
    },
    {
        code: '207VM0101X',
        label: 'Obstetrics & Gynecology / Maternal & Fetal Medicine'
    },
    { code: '207VX0000X', label: 'Obstetrics & Gynecology / Obstetrics' },
    {
        code: '207YX0905X',
        label: 'Otolaryngology / Otolaryngology/Facial Plastic Surgery'
    },
    { code: '225700000X', label: 'Massage Therapist' },
    {
        code: '207VX0201X',
        label: 'Obstetrics & Gynecology / Gynecologic Oncology'
    },
    { code: '207W00000X', label: 'Ophthalmology' },
    {
        code: '207WX0200X',
        label: 'Ophthalmology / Ophthalmic Plastic and Reconstructive Surgery'
    },
    { code: '207X00000X', label: 'Orthopaedic Surgery' },
    {
        code: '207XP3100X',
        label: 'Orthopaedic Surgery / Pediatric Orthopaedic Surgery'
    },
    { code: '207XS0106X', label: 'Orthopaedic Surgery / Hand Surgery' },
    {
        code: '207XS0114X',
        label: 'Orthopaedic Surgery / Adult Reconstructive Orthopaedic Surgery'
    },
    {
        code: '207XS0117X',
        label: 'Orthopaedic Surgery / Orthopaedic Surgery of the Spine'
    },
    {
        code: '207XX0004X',
        label: 'Orthopaedic Surgery / Foot and Ankle Surgery'
    },
    { code: '246QM0900X', label: 'Spec/Tech, Pathology / Microbiology' },
    { code: '207XX0005X', label: 'Orthopaedic Surgery / Sports Medicine' },
    { code: '207XX0801X', label: 'Orthopaedic Surgery / Orthopaedic Trauma' },
    { code: '207Y00000X', label: 'Otolaryngology' },
    { code: '207YP0228X', label: 'Otolaryngology / Pediatric Otolaryngology' },
    { code: '207YS0012X', label: 'Otolaryngology / Sleep Medicine' },
    { code: '207YS0123X', label: 'Otolaryngology / Facial Plastic Surgery' },
    {
        code: '207YX0007X',
        label: 'Otolaryngology / Plastic Surgery within the Head & Neck'
    },
    { code: '207YX0602X', label: 'Otolaryngology / Otolaryngic Allergy' },
    { code: '207YX0901X', label: 'Otolaryngology / Otology & Neurotology' },
    { code: '261QM0850X', label: 'Clinic/Center / Adult Mental Health' },
    {
        code: '207ZB0001X',
        label: 'Pathology / Blood Banking & Transfusion Medicine'
    },
    { code: '207ZC0006X', label: 'Pathology / Clinical Pathology' },
    { code: '207ZC0008X', label: 'Pathology / Clinical Informatics' },
    { code: '207ZC0500X', label: 'Pathology / Cytopathology' },
    { code: '207ZD0900X', label: 'Pathology / Dermatopathology' },
    { code: '207ZF0201X', label: 'Pathology / Forensic Pathology' },
    { code: '207ZH0000X', label: 'Pathology / Hematology' },
    { code: '207ZI0100X', label: 'Pathology / Immunopathology' },
    { code: '207ZM0300X', label: 'Pathology / Medical Microbiology' },
    { code: '207ZN0500X', label: 'Pathology / Neuropathology' },
    { code: '207ZP0007X', label: 'Pathology / Molecular Genetic Pathology' },
    { code: '207ZP0101X', label: 'Pathology / Anatomic Pathology' },
    {
        code: '207ZP0102X',
        label: 'Pathology / Anatomic Pathology & Clinical Pathology'
    },
    { code: '207ZP0104X', label: 'Pathology / Chemical Pathology' },
    {
        code: '2080P0006X',
        label: 'Pediatrics / Developmental – Behavioral Pediatrics'
    },
    {
        code: '207ZP0105X',
        label: 'Pathology / Clinical Pathology/Laboratory Medicine'
    },
    { code: '207ZP0213X', label: 'Pathology / Pediatric Pathology' },
    { code: '208000000X', label: 'Pediatrics' },
    { code: '2080A0000X', label: 'Pediatrics / Adolescent Medicine' },
    { code: '2080B0002X', label: 'Pediatrics / Obesity Medicine' },
    { code: '2080C0008X', label: 'Pediatrics / Child Abuse Pediatrics' },
    {
        code: '2080H0002X',
        label: 'Pediatrics / Hospice and Palliative Medicine'
    },
    {
        code: '2080I0007X',
        label: 'Pediatrics / Clinical & Laboratory Immunology'
    },
    { code: '2080N0001X', label: 'Pediatrics / Neonatal-Perinatal Medicine' },
    { code: '282NW0100X', label: 'General Acute Care Hospital / Women' },
    {
        code: '2080P0008X',
        label: 'Pediatrics / Neurodevelopmental Disabilities'
    },
    { code: '2080P0201X', label: 'Pediatrics / Pediatric Allergy/Immunology' },
    { code: '2080P0202X', label: 'Pediatrics / Pediatric Cardiology' },
    {
        code: '2080P0203X',
        label: 'Pediatrics / Pediatric Critical Care Medicine'
    },
    { code: '2080P0204X', label: 'Pediatrics / Pediatric Emergency Medicine' },
    { code: '2080P0205X', label: 'Pediatrics / Pediatric Endocrinology' },
    { code: '2080P0206X', label: 'Pediatrics / Pediatric Gastroenterology' },
    { code: '2080P0207X', label: 'Pediatrics / Pediatric Hematology-Oncology' },
    { code: '2080P0208X', label: 'Pediatrics / Pediatric Infectious Diseases' },
    { code: '2080P0210X', label: 'Pediatrics / Pediatric Nephrology' },
    { code: '2080P0214X', label: 'Pediatrics / Pediatric Pulmonology' },
    { code: '2080P0216X', label: 'Pediatrics / Pediatric Rheumatology' },
    { code: '2080S0010X', label: 'Pediatrics / Sports Medicine' },
    { code: '2080S0012X', label: 'Pediatrics / Sleep Medicine' },
    { code: '2080T0002X', label: 'Pediatrics / Medical Toxicology' },
    {
        code: '2080T0004X',
        label: 'Pediatrics / Pediatric Transplant Hepatology'
    },
    {
        code: '2081S0010X',
        label: 'Physical Medicine & Rehabilitation / Sports Medicine'
    },
    {
        code: '2279S1500X',
        label: 'Respiratory Therapist, Registered / SNF/Subacute Care'
    },
    { code: '208100000X', label: 'Physical Medicine & Rehabilitation' },
    {
        code: '2081H0002X',
        label: 'Physical Medicine & Rehabilitation / Hospice and Palliative Medicine'
    },
    {
        code: '2081N0008X',
        label: 'Physical Medicine & Rehabilitation / Neuromuscular Medicine'
    },
    {
        code: '2081P0004X',
        label: 'Physical Medicine & Rehabilitation / Spinal Cord Injury Medicine'
    },
    {
        code: '2081P0010X',
        label: 'Physical Medicine & Rehabilitation / Pediatric Rehabilitation Medicine'
    },
    {
        code: '2081P0301X',
        label: 'Physical Medicine & Rehabilitation / Brain Injury Medicine'
    },
    {
        code: '2081P2900X',
        label: 'Physical Medicine & Rehabilitation / Pain Medicine'
    },
    {
        code: '2084P0805X',
        label: 'Psychiatry & Neurology / Geriatric Psychiatry'
    },
    { code: '208200000X', label: 'Plastic Surgery' },
    {
        code: '2082S0099X',
        label: 'Plastic Surgery / Plastic Surgery Within the Head and Neck'
    },
    { code: '2082S0105X', label: 'Plastic Surgery / Surgery of the Hand' },
    { code: '2083A0100X', label: 'Preventive Medicine / Aerospace Medicine' },
    { code: '2083B0002X', label: 'Preventive Medicine / Obesity Medicine' },
    { code: '2083C0008X', label: 'Preventive Medicine / Clinical Informatics' },
    {
        code: '2083P0011X',
        label: 'Preventive Medicine / Undersea and Hyperbaric Medicine'
    },
    {
        code: '2083P0500X',
        label: 'Preventive Medicine / Preventive Medicine/Occupational Environmental Medicine'
    },
    { code: '246QC1000X', label: 'Spec/Tech, Pathology / Chemistry' },
    {
        code: '2083P0901X',
        label: 'Preventive Medicine / Public Health & General Preventive Medicine'
    },
    { code: '2083S0010X', label: 'Preventive Medicine / Sports Medicine' },
    { code: '2083T0002X', label: 'Preventive Medicine / Medical Toxicology' },
    {
        code: '2083X0100X',
        label: 'Preventive Medicine / Occupational Medicine'
    },
    {
        code: '2084A0401X',
        label: 'Psychiatry & Neurology / Addiction Medicine'
    },
    {
        code: '2084A2900X',
        label: 'Psychiatry & Neurology / Neurocritical Care'
    },
    { code: '2084B0002X', label: 'Psychiatry & Neurology / Obesity Medicine' },
    {
        code: '2084B0040X',
        label: 'Psychiatry & Neurology / Behavioral Neurology & Neuropsychiatry'
    },
    {
        code: '2084D0003X',
        label: 'Psychiatry & Neurology / Diagnostic Neuroimaging'
    },
    {
        code: '2084F0202X',
        label: 'Psychiatry & Neurology / Forensic Psychiatry'
    },
    { code: '246QC2700X', label: 'Spec/Tech, Pathology / Cytotechnology' },
    {
        code: '2084H0002X',
        label: 'Psychiatry & Neurology / Hospice and Palliative Medicine'
    },
    {
        code: '2084N0008X',
        label: 'Psychiatry & Neurology / Neuromuscular Medicine'
    },
    { code: '2084N0400X', label: 'Psychiatry & Neurology / Neurology' },
    {
        code: '2084N0402X',
        label: 'Psychiatry & Neurology / Neurology with Special Qualifications in Child Neurology'
    },
    {
        code: '2084N0600X',
        label: 'Psychiatry & Neurology / Clinical Neurophysiology'
    },
    {
        code: '2084P0005X',
        label: 'Psychiatry & Neurology / Neurodevelopmental Disabilities'
    },
    {
        code: '2084P0015X',
        label: 'Psychiatry & Neurology / Psychosomatic Medicine'
    },
    {
        code: '2084P0301X',
        label: 'Psychiatry & Neurology / Brain Injury Medicine'
    },
    { code: '2084P0800X', label: 'Psychiatry & Neurology / Psychiatry' },
    {
        code: '2084P0802X',
        label: 'Psychiatry & Neurology / Addiction Psychiatry'
    },
    {
        code: '2084P0804X',
        label: 'Psychiatry & Neurology / Child & Adolescent Psychiatry'
    },
    {
        code: '2278P1005X',
        label: 'Respiratory Therapist, Certified / Pulmonary Rehabilitation'
    },
    { code: '2084P2900X', label: 'Psychiatry & Neurology / Pain Medicine' },
    { code: '2084S0010X', label: 'Psychiatry & Neurology / Sports Medicine' },
    { code: '2084S0012X', label: 'Psychiatry & Neurology / Sleep Medicine' },
    {
        code: '2084V0102X',
        label: 'Psychiatry & Neurology / Vascular Neurology'
    },
    { code: '2085B0100X', label: 'Radiology / Body Imaging' },
    { code: '2085D0003X', label: 'Radiology / Diagnostic Neuroimaging' },
    {
        code: '2085H0002X',
        label: 'Radiology / Hospice and Palliative Medicine'
    },
    { code: '2085N0700X', label: 'Radiology / Neuroradiology' },
    { code: '2085N0904X', label: 'Radiology / Nuclear Radiology' },
    { code: '2085P0229X', label: 'Radiology / Pediatric Radiology' },
    { code: '2085R0202X', label: 'Radiology / Diagnostic Radiology' },
    { code: '2085R0203X', label: 'Radiology / Therapeutic Radiology' },
    {
        code: '2085R0204X',
        label: 'Radiology / Vascular & Interventional Radiology'
    },
    { code: '2085R0205X', label: 'Radiology / Radiological Physics' },
    { code: '2085U0001X', label: 'Radiology / Diagnostic Ultrasound' },
    { code: '208600000X', label: 'Surgery' },
    { code: '2086H0002X', label: 'Surgery / Hospice and Palliative Medicine' },
    { code: '2086S0102X', label: 'Surgery / Surgical Critical Care' },
    { code: '2086S0105X', label: 'Surgery / Surgery of the Hand' },
    { code: '2086S0120X', label: 'Surgery / Pediatric Surgery' },
    {
        code: '2086S0122X',
        label: 'Surgery / Plastic and Reconstructive Surgery'
    },
    {
        code: '2279P3800X',
        label: 'Respiratory Therapist, Registered / Palliative/Hospice'
    },
    { code: '2086S0127X', label: 'Surgery / Trauma Surgery' },
    { code: '2086S0129X', label: 'Surgery / Vascular Surgery' },
    { code: '2086X0206X', label: 'Surgery / Surgical Oncology' },
    { code: '208800000X', label: 'Urology' },
    {
        code: '2088F0040X',
        label: 'Urology / Female Pelvic Medicine and Reconstructive Surgery'
    },
    { code: '2088P0231X', label: 'Urology / Pediatric Urology' },
    { code: '208C00000X', label: 'Colon & Rectal Surgery' },
    { code: '208D00000X', label: 'General Practice' },
    {
        code: '208G00000X',
        label: 'Thoracic Surgery (Cardiothoracic Vascular Surgery)'
    },
    { code: '225800000X', label: 'Recreation Therapist' },
    { code: '208U00000X', label: 'Clinical Pharmacology' },
    { code: '208VP0000X', label: 'Pain Medicine / Pain Medicine' },
    {
        code: '208VP0014X',
        label: 'Pain Medicine / Interventional Pain Medicine'
    },
    { code: '209800000X', label: 'Legal Medicine' },
    { code: '211D00000X', label: 'Assistant, Podiatric' },
    { code: '213E00000X', label: 'Podiatrist' },
    { code: '213EG0000X', label: 'Podiatrist / General Practice' },
    { code: '213EP0504X', label: 'Podiatrist / Public Medicine' },
    { code: '213EP1101X', label: 'Podiatrist / Primary Podiatric Medicine' },
    { code: '213ER0200X', label: 'Podiatrist / Radiology' },
    { code: '213ES0000X', label: 'Podiatrist / Sports Medicine' },
    { code: '213ES0103X', label: 'Podiatrist / Foot & Ankle Surgery' },
    { code: '213ES0131X', label: 'Podiatrist / Foot Surgery' },
    { code: '221700000X', label: 'Art Therapist' },
    { code: '225A00000X', label: 'Music Therapist' },
    {
        code: '2279P3900X',
        label: 'Respiratory Therapist, Registered / Neonatal/Pediatrics'
    },
    { code: '222Q00000X', label: 'Developmental Therapist' },
    { code: '222Z00000X', label: 'Orthotist' },
    { code: '224900000X', label: 'Mastectomy Fitter' },
    { code: '224L00000X', label: 'Pedorthist' },
    { code: '224P00000X', label: 'Prosthetist' },
    { code: '224Y00000X', label: 'Clinical Exercise Physiologist' },
    { code: '224Z00000X', label: 'Occupational Therapy Assistant' },
    { code: '225B00000X', label: 'Pulmonary Function Technologist' },
    {
        code: '2279P4000X',
        label: 'Respiratory Therapist, Registered / Patient Transport'
    },
    { code: '246QH0000X', label: 'Spec/Tech, Pathology / Hematology' },
    {
        code: '224ZE0001X',
        label: 'Occupational Therapy Assistant / Environmental Modification'
    },
    {
        code: '224ZF0002X',
        label: 'Occupational Therapy Assistant / Feeding, Eating & Swallowing'
    },
    {
        code: '224ZL0004X',
        label: 'Occupational Therapy Assistant / Low Vision'
    },
    {
        code: '224ZR0403X',
        label: 'Occupational Therapy Assistant / Driving and Community Mobility'
    },
    { code: '225000000X', label: 'Orthotic Fitter' },
    { code: '225100000X', label: 'Physical Therapist' },
    { code: '2251C2600X', label: 'Physical Therapist / Cardiopulmonary' },
    { code: '2251E1200X', label: 'Physical Therapist / Ergonomics' },
    {
        code: '2251E1300X',
        label: 'Physical Therapist / Electrophysiology, Clinical'
    },
    { code: '2251G0304X', label: 'Physical Therapist / Geriatrics' },
    { code: '2251H1200X', label: 'Physical Therapist / Hand' },
    { code: '2251H1300X', label: 'Physical Therapist / Human Factors' },
    { code: '2251N0400X', label: 'Physical Therapist / Neurology' },
    { code: '2251P0200X', label: 'Physical Therapist / Pediatrics' },
    { code: '2251S0007X', label: 'Physical Therapist / Sports' },
    { code: '2251X0800X', label: 'Physical Therapist / Orthopedic' },
    { code: '225200000X', label: 'Physical Therapy Assistant' },
    { code: '225400000X', label: 'Rehabilitation Practitioner' },
    { code: '225500000X', label: 'Specialist/Technologist' },
    { code: '2255A2300X', label: 'Specialist/Technologist / Athletic Trainer' },
    {
        code: '2255R0406X',
        label: 'Specialist/Technologist / Rehabilitation, Blind'
    },
    { code: '225600000X', label: 'Dance Therapist' },
    { code: '225C00000X', label: 'Rehabilitation Counselor' },
    {
        code: '225CA2400X',
        label: 'Rehabilitation Counselor / Assistive Technology Practitioner'
    },
    {
        code: '225CA2500X',
        label: 'Rehabilitation Counselor / Assistive Technology Supplier'
    },
    {
        code: '225CX0006X',
        label: 'Rehabilitation Counselor / Orientation and Mobility Training Provider'
    },
    { code: '225X00000X', label: 'Occupational Therapist' },
    {
        code: '225XE0001X',
        label: 'Occupational Therapist / Environmental Modification'
    },
    { code: '225XE1200X', label: 'Occupational Therapist / Ergonomics' },
    {
        code: '2278E1000X',
        label: 'Respiratory Therapist, Certified / Educational'
    },
    {
        code: '2278G0305X',
        label: 'Respiratory Therapist, Certified / Geriatric Care'
    },
    {
        code: '2278G1100X',
        label: 'Respiratory Therapist, Certified / General Care'
    },
    {
        code: '225XF0002X',
        label: 'Occupational Therapist / Feeding, Eating & Swallowing'
    },
    { code: '225XG0600X', label: 'Occupational Therapist / Gerontology' },
    { code: '225XH1200X', label: 'Occupational Therapist / Hand' },
    { code: '225XH1300X', label: 'Occupational Therapist / Human Factors' },
    { code: '225XL0004X', label: 'Occupational Therapist / Low Vision' },
    { code: '225XM0800X', label: 'Occupational Therapist / Mental Health' },
    {
        code: '225XN1300X',
        label: 'Occupational Therapist / Neurorehabilitation'
    },
    {
        code: '2278H0200X',
        label: 'Respiratory Therapist, Certified / Home Health'
    },
    {
        code: '225XP0019X',
        label: 'Occupational Therapist / Physical Rehabilitation'
    },
    { code: '225XP0200X', label: 'Occupational Therapist / Pediatrics' },
    {
        code: '225XR0403X',
        label: 'Occupational Therapist / Driving and Community Mobility'
    },
    { code: '226000000X', label: 'Recreational Therapist Assistant' },
    { code: '226300000X', label: 'Kinesiotherapist' },
    { code: '227800000X', label: 'Respiratory Therapist, Certified' },
    {
        code: '2278C0205X',
        label: 'Respiratory Therapist, Certified / Critical Care'
    },
    {
        code: '2278E0002X',
        label: 'Respiratory Therapist, Certified / Emergency Care'
    },
    {
        code: '2278P1006X',
        label: 'Respiratory Therapist, Certified / Pulmonary Function Technologist'
    },
    {
        code: '2278P3800X',
        label: 'Respiratory Therapist, Certified / Palliative/Hospice'
    },
    {
        code: '2278P3900X',
        label: 'Respiratory Therapist, Certified / Neonatal/Pediatrics'
    },
    {
        code: '2278P4000X',
        label: 'Respiratory Therapist, Certified / Patient Transport'
    },
    {
        code: '2278S1500X',
        label: 'Respiratory Therapist, Certified / SNF/Subacute Care'
    },
    { code: '227900000X', label: 'Respiratory Therapist, Registered' },
    {
        code: '2279C0205X',
        label: 'Respiratory Therapist, Registered / Critical Care'
    },
    {
        code: '2279E0002X',
        label: 'Respiratory Therapist, Registered / Emergency Care'
    },
    {
        code: '2279E1000X',
        label: 'Respiratory Therapist, Registered / Educational'
    },
    {
        code: '2279G0305X',
        label: 'Respiratory Therapist, Registered / Geriatric Care'
    },
    {
        code: '2279G1100X',
        label: 'Respiratory Therapist, Registered / General Care'
    },
    {
        code: '2279H0200X',
        label: 'Respiratory Therapist, Registered / Home Health'
    },
    {
        code: '2279P1004X',
        label: 'Respiratory Therapist, Registered / Pulmonary Diagnostics'
    },
    {
        code: '2279P1005X',
        label: 'Respiratory Therapist, Registered / Pulmonary Rehabilitation'
    },
    {
        code: '2279P1006X',
        label: 'Respiratory Therapist, Registered / Pulmonary Function Technologist'
    },
    { code: '229N00000X', label: 'Anaplastologist' },
    { code: '231H00000X', label: 'Audiologist' },
    {
        code: '231HA2400X',
        label: 'Audiologist / Assistive Technology Practitioner'
    },
    {
        code: '231HA2500X',
        label: 'Audiologist / Assistive Technology Supplier'
    },
    { code: '235500000X', label: 'Specialist/Technologist' },
    {
        code: '2355A2700X',
        label: 'Specialist/Technologist / Audiology Assistant'
    },
    {
        code: '2355S0801X',
        label: 'Specialist/Technologist / Speech-Language Assistant'
    },
    { code: '235Z00000X', label: 'Speech-Language Pathologist' },
    { code: '237600000X', label: 'Audiologist-Hearing Aid Fitter' },
    { code: '237700000X', label: 'Hearing Instrument Specialist' },
    { code: '242T00000X', label: 'Perfusionist' },
    { code: '243U00000X', label: 'Radiology Practitioner Assistant' },
    { code: '246Q00000X', label: 'Spec/Tech, Pathology' },
    { code: '246QB0000X', label: 'Spec/Tech, Pathology / Blood Banking' },
    { code: '246R00000X', label: 'Technician, Pathology' },
    { code: '246RH0600X', label: 'Technician, Pathology / Histology' },
    { code: '246RM2200X', label: 'Technician, Pathology / Medical Laboratory' },
    { code: '246RP1900X', label: 'Technician, Pathology / Phlebotomy' },
    { code: '246W00000X', label: 'Technician, Cardiology' },
    { code: '246X00000X', label: 'Spec/Tech, Cardiovascular' },
    {
        code: '246XC2901X',
        label: 'Spec/Tech, Cardiovascular / Cardiovascular Invasive Specialist'
    },
    {
        code: '246XC2903X',
        label: 'Spec/Tech, Cardiovascular / Vascular Specialist'
    },
    { code: '246XS1301X', label: 'Spec/Tech, Cardiovascular / Sonography' },
    { code: '246Y00000X', label: 'Spec/Tech, Health Info' },
    {
        code: '246YC3301X',
        label: 'Spec/Tech, Health Info / Coding Specialist, Hospital Based'
    },
    {
        code: '246YC3302X',
        label: 'Spec/Tech, Health Info / Coding Specialist, Physician Office Based'
    },
    {
        code: '246YR1600X',
        label: 'Spec/Tech, Health Info / Registered Record Administrator'
    },
    { code: '246Z00000X', label: 'Specialist/Technologist, Other' },
    {
        code: '246ZA2600X',
        label: 'Specialist/Technologist, Other / Art, Medical'
    },
    {
        code: '246ZB0301X',
        label: 'Specialist/Technologist, Other / Biomedical Engineering'
    },
    {
        code: '246ZB0302X',
        label: 'Specialist/Technologist, Other / Biomedical Photographer'
    },
    {
        code: '246ZB0500X',
        label: 'Specialist/Technologist, Other / Biochemist'
    },
    {
        code: '246ZB0600X',
        label: 'Specialist/Technologist, Other / Biostatistician'
    },
    {
        code: '246ZC0007X',
        label: 'Specialist/Technologist, Other / Surgical Assistant'
    },
    { code: '246ZE0500X', label: 'Specialist/Technologist, Other / EEG' },
    {
        code: '246ZE0600X',
        label: 'Specialist/Technologist, Other / Electroneurodiagnostic'
    },
    {
        code: '246ZG0701X',
        label: 'Specialist/Technologist, Other / Graphics Methods'
    },
    {
        code: '246ZG1000X',
        label: 'Specialist/Technologist, Other / Geneticist, Medical (PhD)'
    },
    {
        code: '246ZI1000X',
        label: 'Specialist/Technologist, Other / Illustration, Medical'
    },
    {
        code: '246ZN0300X',
        label: 'Specialist/Technologist, Other / Nephrology'
    },
    {
        code: '246ZS0410X',
        label: 'Specialist/Technologist, Other / Surgical Technologist'
    },
    {
        code: '246ZX2200X',
        label: 'Specialist/Technologist, Other / Orthopedic Assistant'
    },
    { code: '247000000X', label: 'Technician, Health Information' },
    {
        code: '2470A2800X',
        label: 'Technician, Health Information / Assistant Record Technician'
    },
    { code: '247100000X', label: 'Radiologic Technologist' },
    {
        code: '2471B0102X',
        label: 'Radiologic Technologist / Bone Densitometry'
    },
    {
        code: '2471C1101X',
        label: 'Radiologic Technologist / Cardiovascular-Interventional Technology'
    },
    {
        code: '2471C1106X',
        label: 'Radiologic Technologist / Cardiac-Interventional Technology'
    },
    {
        code: '2471C3401X',
        label: 'Radiologic Technologist / Computed Tomography'
    },
    { code: '2471C3402X', label: 'Radiologic Technologist / Radiography' },
    {
        code: '2471M1202X',
        label: 'Radiologic Technologist / Magnetic Resonance Imaging'
    },
    { code: '2471M2300X', label: 'Radiologic Technologist / Mammography' },
    {
        code: '2471N0900X',
        label: 'Radiologic Technologist / Nuclear Medicine Technology'
    },
    {
        code: '2471Q0001X',
        label: 'Radiologic Technologist / Quality Management'
    },
    {
        code: '2471R0002X',
        label: 'Radiologic Technologist / Radiation Therapy'
    },
    { code: '2471S1302X', label: 'Radiologic Technologist / Sonography' },
    {
        code: '2471V0105X',
        label: 'Radiologic Technologist / Vascular Sonography'
    },
    {
        code: '2471V0106X',
        label: 'Radiologic Technologist / Vascular-Interventional Technology'
    },
    { code: '247200000X', label: 'Technician, Other' },
    { code: '2472B0301X', label: 'Technician, Other / Biomedical Engineering' },
    { code: '2472D0500X', label: 'Technician, Other / Darkroom' },
    { code: '2472E0500X', label: 'Technician, Other / EEG' },
    { code: '2472R0900X', label: 'Technician, Other / Renal Dialysis' },
    { code: '2472V0600X', label: 'Technician, Other / Veterinary' },
    {
        code: '247ZC0005X',
        label: 'Pathology / Clinical Laboratory Director, Non-physician'
    },
    { code: '251300000X', label: 'Local Education Agency (LEA)' },
    {
        code: '261QM0855X',
        label: 'Clinic/Center / Adolescent and Children Mental Health'
    },
    { code: '251B00000X', label: 'Case Management' },
    {
        code: '251C00000X',
        label: 'Day Training, Developmentally Disabled Services'
    },
    { code: '251E00000X', label: 'Home Health' },
    { code: '251F00000X', label: 'Home Infusion' },
    { code: '251G00000X', label: 'Hospice Care, Community Based' },
    { code: '251J00000X', label: 'Nursing Care' },
    { code: '251K00000X', label: 'Public Health or Welfare' },
    { code: '251S00000X', label: 'Community/Behavioral Health' },
    { code: '251T00000X', label: 'PACE Provider Organization' },
    { code: '251V00000X', label: 'Voluntary or Charitable' },
    { code: '251X00000X', label: 'Supports Brokerage' },
    { code: '252Y00000X', label: 'Early Intervention Provider Agency' },
    { code: '261QM1000X', label: 'Clinic/Center / Migrant Health' },
    { code: '253J00000X', label: 'Foster Care Agency' },
    { code: '253Z00000X', label: 'In Home Supportive Care' },
    { code: '261Q00000X', label: 'Clinic/Center' },
    {
        code: '261QA0005X',
        label: 'Clinic/Center / Ambulatory Family Planning Facility'
    },
    {
        code: '261QA0006X',
        label: 'Clinic/Center / Ambulatory Fertility Facility'
    },
    { code: '261QA0600X', label: 'Clinic/Center / Adult Day Care' },
    { code: '261QA0900X', label: 'Clinic/Center / Amputee' },
    { code: '261QA1903X', label: 'Clinic/Center / Ambulatory Surgical' },
    { code: '261QA3000X', label: 'Clinic/Center / Augmentative Communication' },
    { code: '261QB0400X', label: 'Clinic/Center / Birthing' },
    { code: '261QC0050X', label: 'Clinic/Center / Critical Access Hospital' },
    { code: '261QC1500X', label: 'Clinic/Center / Community Health' },
    { code: '261QC1800X', label: 'Clinic/Center / Corporate Health' },
    { code: '261QD0000X', label: 'Clinic/Center / Dental' },
    { code: '261QD1600X', label: 'Clinic/Center / Developmental Disabilities' },
    { code: '261QE0002X', label: 'Clinic/Center / Emergency Care' },
    {
        code: '261QE0700X',
        label: 'Clinic/Center / End-Stage Renal Disease (ESRD) Treatment'
    },
    { code: '261QE0800X', label: 'Clinic/Center / Endoscopy' },
    {
        code: '261QF0050X',
        label: 'Clinic/Center / Family Planning, Non-Surgical'
    },
    {
        code: '261QF0400X',
        label: 'Clinic/Center / Federally Qualified Health Center (FQHC)'
    },
    { code: '261QG0250X', label: 'Clinic/Center / Genetics' },
    { code: '261QH0100X', label: 'Clinic/Center / Health Service' },
    { code: '261QH0700X', label: 'Clinic/Center / Hearing and Speech' },
    { code: '261QI0500X', label: 'Clinic/Center / Infusion Therapy' },
    { code: '261QL0400X', label: 'Clinic/Center / Lithotripsy' },
    {
        code: '261QM0801X',
        label: 'Clinic/Center / Mental Health (Including Community Mental Health Center)'
    },
    { code: '261QX0100X', label: 'Clinic/Center / Occupational Medicine' },
    {
        code: '261QM1100X',
        label: 'Clinic/Center / Military/U.S. Coast Guard Outpatient'
    },
    {
        code: '261QM1101X',
        label: 'Clinic/Center / Military and U.S. Coast Guard Ambulatory Procedure'
    },
    {
        code: '261QM1102X',
        label: 'Clinic/Center / Military Outpatient Operational (Transportable) Component'
    },
    {
        code: '261QM1103X',
        label: 'Clinic/Center / Military Ambulatory Procedure Visits Operational (Transportable)'
    },
    {
        code: '261QM1200X',
        label: 'Clinic/Center / Magnetic Resonance Imaging (MRI)'
    },
    { code: '261QM1300X', label: 'Clinic/Center / Multi-Specialty' },
    { code: '261QM2500X', label: 'Clinic/Center / Medical Specialty' },
    { code: '261QM2800X', label: 'Clinic/Center / Methadone Clinic' },
    {
        code: '261QM3000X',
        label: 'Clinic/Center / Medically Fragile Intants and Children Day Care'
    },
    { code: '261QP0904X', label: 'Clinic/Center / Public Health, Federal' },
    {
        code: '261QP0905X',
        label: 'Clinic/Center / Public Health, State or Local'
    },
    { code: '261QP1100X', label: 'Clinic/Center / Podiatric' },
    { code: '261QP2000X', label: 'Clinic/Center / Physical Therapy' },
    { code: '261QP2300X', label: 'Clinic/Center / Primary Care' },
    { code: '261QP2400X', label: 'Clinic/Center / Prison Health' },
    { code: '261QP3300X', label: 'Clinic/Center / Pain' },
    { code: '261QR0200X', label: 'Clinic/Center / Radiology' },
    { code: '261QR0206X', label: 'Clinic/Center / Radiology, Mammography' },
    {
        code: '261QR0207X',
        label: 'Clinic/Center / Radiology, Mobile Mammography'
    },
    { code: '261QR0208X', label: 'Clinic/Center / Radiology, Mobile' },
    { code: '261QR0400X', label: 'Clinic/Center / Rehabilitation' },
    {
        code: '261QR0401X',
        label: 'Clinic/Center / Rehabilitation, Comprehensive Outpatient Rehabilitation Facility (CORF)'
    },
    {
        code: '261QR0404X',
        label: 'Clinic/Center / Rehabilitation, Cardiac Facilities'
    },
    {
        code: '261QR0405X',
        label: 'Clinic/Center / Rehabilitation, Substance Use Disorder'
    },
    { code: '261QR0800X', label: 'Clinic/Center / Recovery Care' },
    { code: '261QR1100X', label: 'Clinic/Center / Research' },
    { code: '261QR1300X', label: 'Clinic/Center / Rural Health' },
    {
        code: '261QS0112X',
        label: 'Clinic/Center / Oral and Maxillofacial Surgery'
    },
    { code: '261QS0132X', label: 'Clinic/Center / Ophthalmologic Surgery' },
    { code: '261QS1000X', label: 'Clinic/Center / Student Health' },
    { code: '261QS1200X', label: 'Clinic/Center / Sleep Disorder Diagnostic' },
    { code: '261QU0200X', label: 'Clinic/Center / Urgent Care' },
    { code: '261QV0200X', label: 'Clinic/Center / VA' },
    { code: '261QX0200X', label: 'Clinic/Center / Oncology' },
    { code: '261QX0203X', label: 'Clinic/Center / Oncology, Radiation' },
    { code: '273100000X', label: 'Epilepsy Unit' },
    { code: '273R00000X', label: 'Psychiatric Unit' },
    { code: '273Y00000X', label: 'Rehabilitation Unit' },
    { code: '275N00000X', label: 'Medicare Defined Swing Bed Unit' },
    {
        code: '276400000X',
        label: 'Rehabilitation, Substance Use Disorder Unit'
    },
    { code: '281P00000X', label: 'Chronic Disease Hospital' },
    { code: '281PC2000X', label: 'Chronic Disease Hospital / Children' },
    { code: '282E00000X', label: 'Long Term Care Hospital' },
    {
        code: '282J00000X',
        label: 'Religious Nonmedical Health Care Institution'
    },
    { code: '282N00000X', label: 'General Acute Care Hospital' },
    {
        code: '282NC0060X',
        label: 'General Acute Care Hospital / Critical Access'
    },
    { code: '283Q00000X', label: 'Psychiatric Hospital' },
    { code: '283X00000X', label: 'Rehabilitation Hospital' },
    { code: '283XC2000X', label: 'Rehabilitation Hospital / Children' },
    { code: '284300000X', label: 'Special Hospital' },
    { code: '286500000X', label: 'Military Hospital' },
    { code: '2865C1500X', label: 'Military Hospital / Community Health' },
    {
        code: '2865M2000X',
        label: 'Military Hospital / Military General Acute Care Hospital'
    },
    {
        code: '2865X1600X',
        label: 'Military Hospital / Military General Acute Care Hospital. Operational (Transportable)'
    },
    { code: '287300000X', label: 'Christian Science Sanitorium' },
    { code: '291900000X', label: 'Military Clinical Medical Laboratory' },
    { code: '291U00000X', label: 'Clinical Medical Laboratory' },
    { code: '292200000X', label: 'Dental Laboratory' },
    { code: '293D00000X', label: 'Physiological Laboratory' },
    { code: '302F00000X', label: 'Exclusive Provider Organization' },
    {
        code: '3140N1450X',
        label: 'Skilled Nursing Facility / Nursing Care, Pediatric'
    },
    { code: '302R00000X', label: 'Health Maintenance Organization' },
    { code: '305R00000X', label: 'Preferred Provider Organization' },
    { code: '305S00000X', label: 'Point of Service' },
    { code: '310400000X', label: 'Assisted Living Facility' },
    {
        code: '3104A0625X',
        label: 'Assisted Living Facility / Assisted Living, Mental Illness'
    },
    {
        code: '3104A0630X',
        label: 'Assisted Living Facility / Assisted Living, Behavioral Disturbances'
    },
    { code: '310500000X', label: 'Intermediate Care Facility, Mental Illness' },
    { code: '311500000X', label: 'Alzheimer Center (Dementia Center)' },
    { code: '311Z00000X', label: 'Custodial Care Facility' },
    { code: '311ZA0620X', label: 'Custodial Care Facility / Adult Care Home' },
    {
        code: '313M00000X',
        label: 'Nursing Facility/Intermediate Care Facility'
    },
    { code: '314000000X', label: 'Skilled Nursing Facility' },
    { code: '315D00000X', label: 'Hospice, Inpatient' },
    {
        code: '315P00000X',
        label: 'Intermediate Care Facility, Mentally Retarded'
    },
    { code: '317400000X', label: 'Christian Science Facility' },
    {
        code: '320600000X',
        label: 'Residential Treatment Facility, Mental Retardation and/or Developmental Disabilities'
    },
    {
        code: '320700000X',
        label: 'Residential Treatment Facility, Physical Disabilities'
    },
    {
        code: '320800000X',
        label: 'Community Based Residential Treatment Facility, Mental Illness'
    },
    {
        code: '320900000X',
        label: 'Community Based Residential Treatment, Mental Retardation and/or Developmental Disabilities'
    },
    {
        code: '322D00000X',
        label: 'Residential Treatment Facility, Emotionally Disturbed Children'
    },
    { code: '323P00000X', label: 'Psychiatric Residential Treatment Facility' },
    { code: '324500000X', label: 'Substance Abuse Rehabilitation Facility' },
    {
        code: '3245S0500X',
        label: 'Substance Abuse Rehabilitation Facility / Substance Abuse Treatment, Children'
    },
    { code: '331L00000X', label: 'Blood Bank' },
    { code: '332000000X', label: 'Military/U.S. Coast Guard Pharmacy' },
    { code: '3336H0001X', label: 'Pharmacy / Home Infusion Therapy Pharmacy' },
    {
        code: '332100000X',
        label: 'Department of Veterans Affairs (VA) Pharmacy'
    },
    {
        code: '332800000X',
        label: 'Indian Health Service/Tribal/Urban Indian Health (I/T/U) Pharmacy'
    },
    { code: '332900000X', label: 'Non-Pharmacy Dispensing Site' },
    {
        code: '332B00000X',
        label: 'Durable Medical Equipment & Medical Supplies'
    },
    {
        code: '332BC3200X',
        label: 'Durable Medical Equipment & Medical Supplies / Customized Equipment'
    },
    {
        code: '332BD1200X',
        label: 'Durable Medical Equipment & Medical Supplies / Dialysis Equipment & Supplies'
    },
    {
        code: '332BN1400X',
        label: 'Durable Medical Equipment & Medical Supplies / Nursing Facility Supplies'
    },
    {
        code: '332BP3500X',
        label: 'Durable Medical Equipment & Medical Supplies / Parenteral & Enteral Nutrition'
    },
    {
        code: '332BX2000X',
        label: 'Durable Medical Equipment & Medical Supplies / Oxygen Equipment & Supplies'
    },
    { code: '332G00000X', label: 'Eye Bank' },
    {
        code: '332H00000X',
        label: 'Eyewear Supplier (Equipment, not the service)'
    },
    { code: '332S00000X', label: 'Hearing  Aid Equipment' },
    { code: '332U00000X', label: 'Home Delivered Meals' },
    { code: '333300000X', label: 'Emergency Response System Companies' },
    { code: '333600000X', label: 'Pharmacy' },
    { code: '3336C0002X', label: 'Pharmacy / Clinic Pharmacy' },
    { code: '3336C0003X', label: 'Pharmacy / Community/Retail Pharmacy' },
    { code: '3336C0004X', label: 'Pharmacy / Compounding Pharmacy' },
    { code: '3336I0012X', label: 'Pharmacy / Institutional Pharmacy' },
    { code: '3336L0003X', label: 'Pharmacy / Long Term Care Pharmacy' },
    { code: '3336M0002X', label: 'Pharmacy / Mail Order Pharmacy' },
    {
        code: '3336M0003X',
        label: 'Pharmacy / Managed Care Organization Pharmacy'
    },
    { code: '3336N0007X', label: 'Pharmacy / Nuclear Pharmacy' },
    { code: '3336S0011X', label: 'Pharmacy / Specialty Pharmacy' },
    { code: '335E00000X', label: 'Prosthetic/Orthotic Supplier' },
    { code: '335G00000X', label: 'Medical Foods Supplier' },
    { code: '335U00000X', label: 'Organ Procurement Organization' },
    {
        code: '335V00000X',
        label: 'Portable X-ray and/or Other Portable Diagnostic Imaging Supplier'
    },
    { code: '341600000X', label: 'Ambulance' },
    { code: '3416A0800X', label: 'Ambulance / Air Transport' },
    { code: '3416L0300X', label: 'Ambulance / Land Transport' },
    { code: '3416S0300X', label: 'Ambulance / Water Transport' },
    { code: '341800000X', label: 'Military/U.S. Coast Guard Transport' },
    {
        code: '3418M1110X',
        label: 'Military/U.S. Coast Guard Transport / Military or U.S. Coast Guard Ambulance, Ground Transport'
    },
    {
        code: '3418M1120X',
        label: 'Military/U.S. Coast Guard Transport / Military or U.S. Coast Guard Ambulance, Air Transport'
    },
    {
        code: '3418M1130X',
        label: 'Military/U.S. Coast Guard Transport / Military or U.S. Coast Guard Ambulance, Water Transport'
    },
    { code: '343800000X', label: 'Secured Medical Transport (VAN)' },
    { code: '343900000X', label: 'Non-emergency Medical Transport (VAN)' },
    { code: '344600000X', label: 'Taxi' },
    { code: '344800000X', label: 'Air Carrier' },
    { code: '347B00000X', label: 'Bus' },
    { code: '347C00000X', label: 'Private Vehicle' },
    { code: '347D00000X', label: 'Train' },
    { code: '347E00000X', label: 'Transportation Broker' },
    { code: '363A00000X', label: 'Physician Assistant' },
    { code: '363AM0700X', label: 'Physician Assistant / Medical' },
    {
        code: '363AS0400X',
        label: 'Physician Assistant / Surgical Technologist'
    },
    { code: '363L00000X', label: 'Nurse Practitioner' },
    { code: '363LA2100X', label: 'Nurse Practitioner / Acute Care' },
    { code: '363LA2200X', label: 'Nurse Practitioner / Adult Health' },
    {
        code: '363LC0200X',
        label: 'Nurse Practitioner / Critical Care Medicine'
    },
    { code: '363LC1500X', label: 'Nurse Practitioner / Community Health' },
    { code: '363LF0000X', label: 'Nurse Practitioner / Family' },
    { code: '363LG0600X', label: 'Nurse Practitioner / Gerontology' },
    { code: '363LN0000X', label: 'Nurse Practitioner / Neonatal' },
    {
        code: '363LN0005X',
        label: 'Nurse Practitioner / Neonatal, Critical Care'
    },
    { code: '363LP0200X', label: 'Nurse Practitioner / Pediatrics' },
    {
        code: '363LP0222X',
        label: 'Nurse Practitioner / Pediatrics, Critical Care'
    },
    { code: '363LP0808X', label: 'Nurse Practitioner / Psych/Mental Health' },
    { code: '363LP1700X', label: 'Nurse Practitioner / Perinatal' },
    { code: '363LP2300X', label: 'Nurse Practitioner / Primary Care' },
    { code: '363LS0200X', label: 'Nurse Practitioner / School' },
    { code: '363LW0102X', label: "Nurse Practitioner / Women's Health" },
    {
        code: '363LX0001X',
        label: 'Nurse Practitioner / Obstetrics & Gynecology'
    },
    { code: '363LX0106X', label: 'Nurse Practitioner / Occupational Health' },
    { code: '376G00000X', label: 'Nursing Home Administrator' },
    { code: '364S00000X', label: 'Clinical Nurse Specialist' },
    { code: '364SA2100X', label: 'Clinical Nurse Specialist / Acute Care' },
    { code: '364SA2200X', label: 'Clinical Nurse Specialist / Adult Health' },
    {
        code: '364SC0200X',
        label: 'Clinical Nurse Specialist / Critical Care Medicine'
    },
    {
        code: '364SC1501X',
        label: 'Clinical Nurse Specialist / Community Health/Public Health'
    },
    { code: '364SC2300X', label: 'Clinical Nurse Specialist / Chronic Care' },
    { code: '364SE0003X', label: 'Clinical Nurse Specialist / Emergency' },
    { code: '364SE1400X', label: 'Clinical Nurse Specialist / Ethics' },
    { code: '364SF0001X', label: 'Clinical Nurse Specialist / Family Health' },
    { code: '364SG0600X', label: 'Clinical Nurse Specialist / Gerontology' },
    { code: '364SH0200X', label: 'Clinical Nurse Specialist / Home Health' },
    { code: '364SH1100X', label: 'Clinical Nurse Specialist / Holistic' },
    { code: '364SI0800X', label: 'Clinical Nurse Specialist / Informatics' },
    { code: '364SL0600X', label: 'Clinical Nurse Specialist / Long-Term Care' },
    {
        code: '364SM0705X',
        label: 'Clinical Nurse Specialist / Medical-Surgical'
    },
    { code: '364SN0000X', label: 'Clinical Nurse Specialist / Neonatal' },
    { code: '364SN0800X', label: 'Clinical Nurse Specialist / Neuroscience' },
    { code: '364SP0200X', label: 'Clinical Nurse Specialist / Pediatrics' },
    {
        code: '364SP0807X',
        label: 'Clinical Nurse Specialist / Psych/Mental Health, Child & Adolescent'
    },
    {
        code: '364SP0808X',
        label: 'Clinical Nurse Specialist / Psych/Mental Health'
    },
    {
        code: '364SP0809X',
        label: 'Clinical Nurse Specialist / Psych/Mental Health, Adult'
    },
    {
        code: '364SP0810X',
        label: 'Clinical Nurse Specialist / Psych/Mental Health, Child & Family'
    },
    {
        code: '364SP0811X',
        label: 'Clinical Nurse Specialist / Psych/Mental Health, Chronically Ill'
    },
    {
        code: '364SP0812X',
        label: 'Clinical Nurse Specialist / Psych/Mental Health, Community'
    },
    {
        code: '364SP0813X',
        label: 'Clinical Nurse Specialist / Psych/Mental Health, Geropsychiatric'
    },
    { code: '364SP1700X', label: 'Clinical Nurse Specialist / Perinatal' },
    { code: '364SP2800X', label: 'Clinical Nurse Specialist / Perioperative' },
    { code: '364SR0400X', label: 'Clinical Nurse Specialist / Rehabilitation' },
    { code: '364SS0200X', label: 'Clinical Nurse Specialist / School' },
    {
        code: '364ST0500X',
        label: 'Clinical Nurse Specialist / Transplantation'
    },
    { code: '364SW0102X', label: "Clinical Nurse Specialist / Women's Health" },
    {
        code: '364SX0106X',
        label: 'Clinical Nurse Specialist / Occupational Health'
    },
    { code: '364SX0200X', label: 'Clinical Nurse Specialist / Oncology' },
    {
        code: '364SX0204X',
        label: 'Clinical Nurse Specialist / Oncology, Pediatrics'
    },
    { code: '367500000X', label: 'Nurse Anesthetist, Certified Registered' },
    { code: '376J00000X', label: 'Homemaker' },
    { code: '367A00000X', label: 'Advanced Practice Midwife' },
    { code: '367H00000X', label: 'Anesthesiologist Assistant' },
    { code: '372500000X', label: 'Chore Provider' },
    { code: '372600000X', label: 'Adult Companion' },
    { code: '373H00000X', label: 'Day Training/Habilitation Specialist' },
    { code: '374700000X', label: 'Technician' },
    { code: '3747A0650X', label: 'Technician / Attendant Care Provider' },
    { code: '3747P1801X', label: 'Technician / Personal Care Attendant' },
    { code: '374J00000X', label: 'Doula' },
    { code: '374K00000X', label: 'Religious Nonmedical Practitioner' },
    { code: '374T00000X', label: 'Religious Nonmedical Nursing Personnel' },
    { code: '374U00000X', label: 'Home Health Aide' },
    { code: '376K00000X', label: "Nurse's Aide" },
    { code: '385H00000X', label: 'Respite Care' },
    { code: '385HR2050X', label: 'Respite Care / Respite Care Camp' },
    {
        code: '385HR2055X',
        label: 'Respite Care / Respite Care, Mental Illness, Child'
    },
    {
        code: '385HR2060X',
        label: 'Respite Care / Respite Care, Mental Retardation and/or Developmenta}l Disabilities, Child'
    },
    {
        code: '385HR2065X',
        label: 'Respite Care / Respite Care, Physical Disabilities, Child'
    },
    {
        code: '390200000X',
        label: 'Student in an Organized Health Care Education/Training Program'
    },
    { code: '405300000X', label: 'Prevention Professional' }
];

module.exports = codes.sort((a, b) => a.label > b.label ? 1 : (a.label === b.label ? 0 : -1)); // eslint-disable-line
